import { put, call } from 'redux-saga/effects';
import { taskCreateAPI, taskSearchAPI, taskUpdateAPI } from 'src/api/TaskApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { toast } from 'react-toastify';
import { TASK_ACTIONS } from '../actions/TaskActions';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(taskSearchAPI, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
            }),
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: TASK_ACTIONS.TASK_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: TASK_ACTIONS.TASK_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(taskSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: TASK_ACTIONS.TASK_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(taskCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        })); 
        toast("Task Created")
        
        yield put({
            type: TASK_ACTIONS.TASK_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
        yield put({
            type: TASK_ACTIONS.TASK_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: TASK_ACTIONS.TASK_UPSERT_ERROR,
        });
    }
}

function* update(taskId, payload) {
    try {
        yield call(taskUpdateAPI, {
            taskId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if(payload.deleted===true){
            toast("Task deleted")
        }
        else{
            toast("Task updated")
        } 
        
        yield put({
            type: TASK_ACTIONS.TASK_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: TASK_ACTIONS.TASK_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(TASK_ACTIONS.TASK_SEARCH, search),
    takeFirstSagaUtil(TASK_ACTIONS.TASK_UPSERT, upsert),
    takeFirstSagaUtil(TASK_ACTIONS.TASK_EDIT, edit),
];
